<template>
  <a
    class="video-collection-video-presenter p-2 text-white h-100"
    :class="playing ? 'active' : ''"
    :href="videoCollectionVideo.url"
    @click.prevent="handleClick"
  >
    <img
      class="item__image"
      :src="videoCollectionVideo.imageUrl"
    >
    <div class="item__content d-flex py-3 align-items-start">
      <div class="d-block text-right item__indicator">
        <small>
          <VsIcon
            v-if="playing"
            icon="md:play_arrow"
          />
          <template v-else>{{ index + 1 }}</template>
        </small>
      </div>
      <div class="item__title">{{ videoCollectionVideo.title }}</div>
    </div>
  </a>
</template>

<script>
import VsIcon from '@/scripts/Components/Molecules/VsIcon';

export default {
  components: {
    VsIcon,
  },
  props: {
    playing: {
      type: Boolean,
      default: false,
    },
    index: {
      type: [String, Number],
      required: true,
    },

    videoCollectionVideo: {
      type: Object,
      required: true,
      validator(videoCollectionVideo) {
        return (
          'title' in videoCollectionVideo &&
          'imageUrl' in videoCollectionVideo &&
          'url' in videoCollectionVideo
        );
      },
    },
  },
  methods: {
    handleClick() {
      this.$emit('click', this.videoCollectionVideo);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-collection-video-presenter {
  box-shadow: 1px 1px 1px 1px rgba(0,0,0,0.05);
}

.video-collection-video-presenter {
  display: flex;
  width: 100%;

  cursor: pointer;

  transition: background-color 0.1s;

  background-color: transparent;
  &:hover {
    background-color: rgba(white, 0.05);
  }
  &:focus,
  &.active,
  &.active:hover {
    background-color: rgba(white, 0.1);
  }
}

.video-collection-video-presenter {
  .item__indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;

    opacity: 0.35;
  }

  &:hover .item__indicator {
    opacity: 0.8;
  }

  &.active .item__indicator {
    opacity: 1;
  }
}

.item__image {
  width: 100%;
  max-width: 100px;
  height: calc(100px / 16 * 9);
  object-fit: cover;
  background-color: rgba(255, 255, 255, 0.1);
}
.item__content {
  flex-grow: 1;
  opacity: 0.8;
}
.video-collection-video-presenter:focus,
.video-collection-video-presenter:hover,
.video-collection-video-presenter.active {
  .item__content {
    opacity: 1.0;
  }
}

.item__title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.item__indicator {
  flex-grow: 0;
  flex-shrink: 0;

  // Tweak position of indicator element
  margin-top: -1px; // Attempt to vertically align self to its title sibling
  padding-left: 4px;
  padding-right: 4px;
}
</style>
